module.exports = __webpack_public_path__ + "img/sec_06.864e1741.jpg";